import { NgModule } from '@angular/core';
import { ArquiteturaModule } from 'src/app/arquitetura/arquitetura.module';
import { FaqPage } from './faq.page';

@NgModule({
  declarations: [
    FaqPage
  ],
  imports: [
    ArquiteturaModule
  ]
})
export class FaqModule { }
